/**
 * Notification Service
 * Handles all notification-related API calls
 */

import api from '../utils/api';

const notificationService = {
  /**
   * Get notifications with pagination
   * @param {Object} filter - Filter parameters (page, pageSize, isRead, type, etc.)
   * @returns {Promise} Notifications response
   */
  getNotifications: async (filter = {}) => {
    const params = {
      page: filter.page || 1,
      pageSize: filter.pageSize || 10,
      ...(filter.isRead !== undefined && { isRead: filter.isRead }),
      ...(filter.type && { type: filter.type }),
      ...(filter.relatedEntityId && { relatedEntityId: filter.relatedEntityId }),
      ...(filter.relatedEntityType && { relatedEntityType: filter.relatedEntityType }),
    };
    const response = await api.get('/notifications', params);
    return response;
  },

  /**
   * Get notification count (unread and total)
   * @returns {Promise} Notification count response
   */
  getNotificationCount: async () => {
    const response = await api.get('/notifications/count');
    return response;
  },

  /**
   * Mark notification as read
   * @param {number} id - Notification ID
   * @returns {Promise} Response
   */
  markAsRead: async (id) => {
    const response = await api.put(`/notifications/${id}/read`);
    return response;
  },

  /**
   * Mark all notifications as read
   * @returns {Promise} Response with count
   */
  markAllAsRead: async () => {
    const response = await api.put('/notifications/read-all');
    return response;
  },

  /**
   * Delete a notification
   * @param {number} id - Notification ID
   * @returns {Promise} Response
   */
  deleteNotification: async (id) => {
    const response = await api.delete(`/notifications/${id}`);
    return response;
  },
};

export default notificationService;

